// extracted by mini-css-extract-plugin
export var container = "_sr-0";
export var table = "_sr-2";
export var tableWrapper = "_sr-1";